// Нова ниша › the pure glue between the rows the wizard reads and the generator in @leadg/shared.

import type { QueryCandidate, QueryTier, TerritoryInput, VerticalVocabulary } from '@leadg/shared';
import type { SettingRow } from '../useAdmin.js';
import type { VerticalRow } from '../verticals/useVerticals.js';
import type { CityAreaRow, CityRow } from '../cities/useCities.js';

export const TIER_LABELS: Readonly<Record<QueryTier, string>> = {
  core: 'Ядро',
  core_area: 'Ядро × район',
  service: 'Услуги',
  service_area: 'Услуги × район',
  intent: 'Намерение',
  en: 'Английски',
};

export const DEFAULT_CAP = 120;

export function toVocabulary(vertical: VerticalRow): VerticalVocabulary {
  return {
    key: vertical.key,
    nameEn: vertical.name_en,
    synonymsBg: vertical.synonyms_bg,
    synonymsLat: vertical.synonyms_lat,
    servicesBg: vertical.services_bg,
    servicesLat: vertical.services_lat,
    searchLanguages: vertical.search_languages,
    intentPhrasingsBg: vertical.intent_phrasings_bg,
  };
}

export function toTerritory(
  city: CityRow,
  areas: readonly CityAreaRow[],
  ticked: ReadonlySet<number>,
): TerritoryInput {
  return {
    cityKey: city.key,
    cityNameBg: city.name_bg,
    cityNameLat: city.name_lat || city.name_en,
    areas: areas.map((area) => ({
      name: area.name,
      nameLat: area.name_lat,
      searchWeight: area.search_weight,
      includeInQueries: ticked.has(area.id),
    })),
  };
}

export function readTierCooldowns(
  settings: readonly SettingRow[],
): Partial<Record<QueryTier, number>> {
  const raw = settings.find((s) => s.key === 'discovery_tier_cooldowns')?.value;
  if (raw === null || typeof raw !== 'object') return {};
  const out: Partial<Record<QueryTier, number>> = {};
  for (const [tier, days] of Object.entries(raw as Record<string, unknown>)) {
    if (typeof days === 'number' && days > 0) out[tier as QueryTier] = days;
  }
  return out;
}

export function readCap(settings: readonly SettingRow[]): number {
  const raw = settings.find((s) => s.key === 'discovery_max_queries_per_run')?.value;
  return typeof raw === 'number' && raw > 0 ? raw : DEFAULT_CAP;
}

/** The search_queries rows a draft batch inserts (plan §3.9 step 2). */
export function toQueryRows(
  candidates: readonly QueryCandidate[],
  batchId: string,
  verticalKey: string,
  cityKey: string,
): Record<string, unknown>[] {
  return candidates.map((c) => ({
    query_text: c.queryText,
    vertical_key: verticalKey,
    city_key: cityKey,
    area_hint: c.areaHint,
    active: false,
    approved_at: null,
    generated_by: 'matrix',
    batch_id: batchId,
    dims: c.dims,
    tier: c.tier,
    expected_yield: c.expectedYield,
    cooldown_days: c.cooldownDays,
    base_cooldown_days: c.cooldownDays,
  }));
}
